import React from "react";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import LogoSlider from "../components/LogoSlider";

function Home() {
  return (
    <div>
      <Hero />
      <LogoSlider />
      <Footer />
    </div>
  );
}

export default Home;
